import { useEffect, useState } from 'react'

import { LocalStorage, LocalStorageOptions } from './LocalStorage'

export type UseLocalStorageOptions<TValue = string> = LocalStorageOptions<TValue>

export function useLocalStorage<TValue = string>(
  key: string,
  options: UseLocalStorageOptions<TValue> = {},
) {
  const [storage] = useState(() => new LocalStorage(key, options))

  const [value, _setValue] = useState<TValue | null>(storage.getCurrentValue)

  useEffect(() => {
    storage.patchOptions(options)
  }, [storage, options])

  useEffect(() => {
    return storage.subscribe(_setValue)
  }, [storage])

  return [value, storage.setValue, storage.getCurrentValue] as const
}
